
import { Component, Watch } from "vue-property-decorator";
import BaseInput from "~/core/BaseInput";
import { _castArray, _head, _isEqual, _isNil } from "~/utils/lodash";

@Component
export default class Checkbox extends BaseInput {
  selected: any = null;

  get getDefaultValue() {
    const value = _head(this.options).value;
    switch (typeof value) {
      case "boolean":
        return typeof this.value === "boolean" ? this.value : false;
      default:
        if (!_isNil(this.value)) {
          return this.options.length > 1 ? _castArray(this.value) : this.value;
        }
        return this.options.length > 1 ? [] : "";
    }
  }

  get theme() {
    return {
      "--primaryLighter": this.$vuetify.theme.themes.light.primaryLighter,
    };
  }

  created() {
    this.syncSelected(this.value);
  }

  syncSelected(value: any) {
    const nextValue = _isNil(value) ? this.getDefaultValue : value;
    if (!_isEqual(this.selected, nextValue)) {
      this.selected = nextValue;
    }
  }

  @Watch("selected", { deep: true })
  onSelected(newValue) {
    this.innerValue = newValue;
  }

  @Watch("value", { deep: true, immediate: true })
  onValueChanged(newValue) {
    this.syncSelected(newValue);
  }
}
